import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { CommonModule, KeyValue } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatChipGrid, MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from '../../auto-unsubscribe.decorator';
import { FormFieldAutoComponent } from '../form-field-auto/form-field-auto.component';
import { MatIconButton } from '@angular/material/button';

@AutoUnsubscribe()
@Component({
  selector: 'app-form-field-multi-chip',
  templateUrl: './form-field-multi-chip.component.html',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatChipsModule, MatIconModule, TranslatePipe, MatIconButton],
})
export class FormFieldMultiChipComponent extends FormFieldAutoComponent implements AfterViewInit {
  @Input()
  chips: KeyValue<string, string>[];

  @Input()
  required: boolean = true;

  @Input()
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @ViewChild(MatAutocompleteTrigger) autocomplete: MatAutocompleteTrigger;
  @ViewChild('chipList') chipList: MatChipGrid;
  @ViewChild('fieldInput') fieldInput: ElementRef<HTMLInputElement>;

  @Output()
  removed = new EventEmitter<string>();

  private errorStateSub: Subscription;

  ngAfterViewInit(): void {
    this.errorStateSub = this.formGroup.controls[this.field].valueChanges.subscribe(() => (this.chipList.errorState = !this.formGroup.controls[this.field].valid));
  }

  notifyListeners(event: MatAutocompleteSelectedEvent): void {
    super.notifyListeners(event);
    // Weird case for mat-chips that don't follow the form field's value
    this.fieldInput.nativeElement.value = '';
    this.resetControlValue();
  }

  remove(id: string): void {
    this.removed.next(id);
    this.resetControlValue();
  }

  updateAndValidate(): void {
    this.formGroup.controls[this.field].updateValueAndValidity();
  }

  matChipInputTokenEnd(): void {
    if (this.suffixButtonAction) {
      this.suffixButtonAction();
    }
  }

  focus(): void {
    this.fieldInput?.nativeElement?.focus();
  }

  blur(): void {
    this.fieldInput?.nativeElement?.blur();
  }
}
